// src/components/Sidebar/WorkflowItem.js

import React from 'react';

const WorkflowItem = ({ label, icon, description }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
        margin: '5px 0',
        backgroundColor: '#fff',
        borderRadius: '4px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        cursor: 'pointer',
      }}
    >
      {icon ? (
        typeof icon === 'string' ? (
          <img
            src={icon}
            alt={label}
            style={{ width: '24px', height: '24px', marginRight: '8px' }}
          />
        ) : (
          <icon.type
            style={{ width: '24px', height: '24px', marginRight: '8px' }}
          />
        )
      ) : (
        <div
          style={{
            width: '24px',
            height: '24px',
            marginRight: '8px',
            backgroundColor: '#ccc',
          }}
        />
      )}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span>{label}</span>
        {description && (
          <span style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
            {description}
          </span>
        )}
      </div>
    </div>
  );
};

export default WorkflowItem;
